import { Service } from 'typedi';
import { BaseListViewModel } from '../../../../../core/services/BaseViewModel';
import { ISpcService } from '../../SpcService';
import { action, makeObservable, observable } from 'mobx';
import { Appl } from '../../../../../core/Appl';
import { ListItem } from '../../../../../core/services/BaseService';
import { SpcSubmissionListModel } from './SpcSubmissionListModel';
import Helper from '../../../../../core/services/Helper';

@Service() // eslint-disable-next-line
export default class SpcSubmissionListViewModel extends BaseListViewModel<SpcSubmissionListModel> {
  private service: ISpcService;

  @observable public submissionStatusList: Array<ListItem> = [];
  @observable public searchText?: string = '';

  constructor() {
    super('Service Purchase Estimate Queue', 'spcTypeSubId', false);
    this.service = Appl.Services.get<ISpcService>('ISpcService');
    makeObservable(this);
  }

  @action
  public async initAsync() {
    
  }

  public async getPagedAsync(): Promise<void> {
    const response = await this.service.getPagedAsync(`/spc/SpcSubmission/search`, this.searchRequest);
    await this.handleGetAllServerResponse(response);
  }

   @action
   public async export(format: string): Promise<void> {
     this.searchRequest = { skip: 0, take: 1000000000, sortColumn: this.searchRequest!.sortColumn, sortAscending: this.searchRequest!.sortAscending, filter: '' };
     const result = await this.service.getQueueAsFileAsync(format, this.searchRequest);
     if (result.success) {
       Helper.downloadFile(result.data, 'ServicePurchaseEstimateQueue.csv', 'text/csv');
     } else {
       Appl.Error.handle(result.error);
     }
   }
}
